import React from "react";
import FormControl  from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import InputLabel from '@material-ui/core/InputLabel'

import RenderError from '../render-error'

import countryList from '../../data/countrylist'

// import DonationContext from '../../context/donation'

const CountryList: React.FC = (props: any) => {

  // const donation = useContext(DonationContext)

  return (
    <>
      <div className="input-container select">
        <FormControl>
          <InputLabel htmlFor="title">Country</InputLabel>
          <Select
            variant="outlined"
            name="country"
            id="country"
            autoComplete="country"
            inputProps={{
              "aria-describedby": "country_error"
            }}
            error={props.errors.country ? true : false}
            value={props.values.country || ''}
            onChange={props.handleChange}>
            {
              countryList.map((country:any, index:any) => {
                return (
                  <MenuItem key={index} value={country.code}>{country.name}</MenuItem>
                )
              })
            }
          </Select>
        </FormControl>
        <RenderError name="country" id="country_error" {...props} />
      </div>
    </>
  );
};

export default CountryList;